import { useTranslation } from 'react-i18next'
import { PlusSquare, Share } from 'lucide-react'
import i18n from 'i18next'
import type { BrowserKind } from '@/lib/push/platform'
import { helpCenterUrl } from '@/lib/helpCenter'

/** The docs article on push (install per platform, unblock, devices, privacy). Written by the docs agent. */
const pushHelpUrl = () => {
  const lang = (i18n.language || 'pt-BR').toLowerCase()
  return helpCenterUrl(lang.startsWith('de') ? 'de-de' : lang, 'conceitos/notificacoes-no-navegador')
}

export const PrivacyLink = ({ className }: { className?: string }) => {
  const { t } = useTranslation('push')
  return (
    <a href={pushHelpUrl()} target="_blank" rel="noopener noreferrer" className={className ?? 'text-xs font-medium text-gray-500 underline underline-offset-2 hover:text-gray-700'} data-push-privacy>
      {t('privacy')}
    </a>
  )
}

const StepNumber = ({ n }: { n: number }) => (
  <span className="flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-primary/10 text-xs font-semibold text-primary">{n}</span>
)

/** iPhone/iPad: Compartilhar → "Adicionar à Tela de Início" → open from the icon and log in again. */
export const IosInstallSteps = () => {
  const { t } = useTranslation('push')
  return (
    <ol className="space-y-3 text-sm text-gray-700" data-push-ios-steps>
      <li className="flex items-start gap-3">
        <StepNumber n={1} />
        <span className="min-w-0">
          {t('install.iosStep1')}
          <span className="ml-1.5 inline-flex h-7 w-7 items-center justify-center rounded-md border border-gray-200 bg-gray-50 align-middle text-[#007AFF]" aria-hidden>
            <Share className="h-4 w-4" />
          </span>
        </span>
      </li>
      <li className="flex items-start gap-3">
        <StepNumber n={2} />
        <span className="min-w-0">
          {t('install.iosStep2')}
          <span className="ml-1.5 inline-flex items-center gap-1 rounded-md border border-gray-200 bg-gray-50 px-2 py-0.5 align-middle text-xs text-gray-800" aria-hidden>
            <PlusSquare className="h-3.5 w-3.5" />{t('install.iosAddLabel')}
          </span>
        </span>
      </li>
      <li className="flex items-start gap-3">
        <StepNumber n={3} />
        <span className="min-w-0">{t('install.iosStep3')}</span>
      </li>
    </ol>
  )
}

/** How to unblock notifications in the browser and system the person is using. */
export const BlockedSteps = ({ kind }: { kind: BrowserKind }) => {
  const { t } = useTranslation('push')
  const key = kind === 'iosSafari' ? 'iosApp' : kind
  return (
    <div className="space-y-2 text-sm text-gray-700" data-push-blocked-steps={key}>
      <p>{t(`blocked.steps.${key}`)}</p>
      <p className="text-xs text-gray-500">{t('blocked.stillNothing')}</p>
    </div>
  )
}
